import { TextField, Grid, Box } from '@mui/material';
import FieldWrapper from './FieldWrapper';

export default function AddressFields({ prefix, data, onChange, errors, metadata, required }) {
  const val = (field) => data[`${prefix}_${field}`] || '';
  const meta = (field) => metadata?.[`${prefix}_${field}`] || {};
  const err = (field) => errors?.[`${prefix}_${field}`];

  const handleChange = (field, value) => {
    onChange(`${prefix}_${field}`, value);
  };

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <FieldWrapper label="Indirizzo" required={required} error={err('indirizzo')} completed={!!val('indirizzo')} locked={meta('indirizzo').editable === false} source={meta('indirizzo').source}>
          <TextField fullWidth size="small" placeholder="Via, piazza, corso..." value={val('indirizzo')} onChange={e => handleChange('indirizzo', e.target.value)} />
        </FieldWrapper>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FieldWrapper label="N. Civico" required={required} error={err('civico')} completed={!!val('civico')} locked={meta('civico').editable === false}>
          <TextField fullWidth size="small" placeholder="N°" value={val('civico')} onChange={e => handleChange('civico', e.target.value)} />
        </FieldWrapper>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FieldWrapper label="CAP" required={required} error={err('cap')} completed={!!val('cap')} locked={meta('cap').editable === false} hint="Inserisci le 5 cifre del codice postale">
          <TextField fullWidth size="small" placeholder="00000" inputProps={{ maxLength: 5 }} value={val('cap')} onChange={e => handleChange('cap', e.target.value)} />
        </FieldWrapper>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FieldWrapper label="Località" required={required} error={err('localita')} completed={!!val('localita')} locked={meta('localita').editable === false}>
          <TextField fullWidth size="small" placeholder="Comune" value={val('localita')} onChange={e => handleChange('localita', e.target.value)} />
        </FieldWrapper>
      </Grid>
      <Grid item xs={12} sm={6}>
        <FieldWrapper label="Provincia" required={required} error={err('provincia')} completed={!!val('provincia')} locked={meta('provincia').editable === false} hint="Sigla a due lettere (es. MI, RM)">
          <TextField fullWidth size="small" placeholder="XX" inputProps={{ maxLength: 2, style: { textTransform: 'uppercase' } }} value={val('provincia')} onChange={e => handleChange('provincia', e.target.value.toUpperCase())} />
        </FieldWrapper>
      </Grid>
    </Grid>
  );
}